import React from 'react';

import RouteFilter from './RouteFilter';
import DateFilter from './DateFilter';

const PrebookingFilters = ({ className, filters, onChange, forecast }) => {
  return (
    <div className={className}>
      <RouteFilter width="150px" filters={filters} onChange={onChange} />
      <DateFilter width="150px" filters={filters} onChange={onChange} />
      <div className="forecast">{forecast}</div>
    </div>
  );
};

export default PrebookingFilters;
